<template>
    <div class="recommend-overlay">
        <!-- 专家推荐 -->
        <van-overlay class-name="recommend-overlay-wapper" :show="overlayShow" @click="overlayShow = false">
            <div class="recommend-overlay" @click.stop>
                <div class="recommend-overlay-top">
                    <span class="recommend-overlay-top-title"> 专家推荐</span>
                    <van-icon name="cross" @click="overlayShow = false" />
                </div>
                <div class="recommend-overlay-content">
                    <div class="recommend-overlay-content-title">
                        服务说明
                    </div>
                    <div class="recommend-overlay-content-introduce">
                        <span>1. 百位血液及肿瘤领域权威医生在线服务</span>
                        <span>2. 1V1解答您的疾病问题</span>
                        <span>3. 可根据医院、疾病、医生姓名等筛选查找</span>
                        <span>4. 根据需求选择图文咨询、视频咨询、问诊开药等服务</span>
                        <span>5. 有问题随时联系专属客服</span>
                    </div>
                </div>

                <div class="recommend-overlay-user-instructions">
                    <van-checkbox v-model="checked" checked-color="#0FB7AD" icon-size="16px">
                        <div class="recommend-overlay-user-instructions-text">
                            请阅读并同意 <a href="/#/xy">《用户协议》</a>及<a href="/#/ys">《隐私政策》</a>
                        </div>
                    </van-checkbox>
                </div>

                <div class="recommend-overlay-operation">
                    <van-button @click="onClick" type="primary" color="#03cbbf" block round>确定</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import {LocationHref} from '@/util/common'

export default {
    props: {
      pageType: {
        type: Number,
        default: 1
      }
    },
    data() {
        return {
            overlayShow: false,
            checked: false
        }
    },
    // watch: {
    //     overlayShow: {
    //         handler(newValue) {
    //             if (newValue) {
    //                 document.body.style.overflow = 'hidden'
    //             } else {
    //                 document.body.style.overflow = 'auto'
    //             }
    //         }
    //     }
    // },
    methods: {
        onClick() {
            if (!this.checked) {
                this.$toast({ message: '请先阅读并同意《用户协议》及《个人隐私协', className: 'toast-overlay' })
                return
            }
          // try {
            // 跳转链接
            LocationHref('https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=expert_rec&t='+localStorage.getItem('user_id')+'&u='+Math.random()*5)
          //   Interface.mFootPrint(1, 86,0, 4, 0, 0,0,'跳转专家推荐链接成功')
          // } catch(error) {
          //   Interface.mFootPrint(1, 87,0, 4, 0, 0,0,'跳转专家推荐链接失败')
          // }
        }
    },
    watch: {
      checked(newVal, oldVal) {
        if (newVal) {
          Interface.mFootPrint(1, 85,0, this.pageType, 0, 0,0,'医疗服务-专家推荐-用户协议勾选')
        }
      }
    }
}
</script>

<style></style>
<style lang="scss" scoped>
.recommend-overlay-wapper {
    z-index: 99999999;

    .recommend-overlay {
        position: absolute;
        bottom: 0px;
        background: #fff;
        width: 100%;
        border-radius: 12px 12px 0 0;

        &-top {
            box-sizing: border-box;
            background: url('/static/bytx/ylfw/medical_head_popup_3@3x.png') no-repeat;
            background-size: 100% 100%;
            background-position: 100% 100%;
            height: 100px;
            width: 100%;
            margin-top: -30px;
            padding-top: 40px;
            text-align: center;
            position: relative;
            .van-icon {
                position: absolute;
                right: 15px;
                top: 40px;
                font-size: 18px;
                width: 30px;
                height: 30px;
            }

            &-title {
                margin-top: 10px;
                display: inline-block;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #282828;
            }
        }

        &-content {
            margin: 0px 20px;
            &-title {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282828;
            }

            &-introduce {
                padding-top: 14px;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #777777;

                span {
                    padding-bottom: 10px;
                }
            }

            .matter {
                margin-top: 10px;
            }
        }

        &-user-instructions {
            margin: 0px 20px;
            margin-top: 14px;
            margin-bottom: 16px;

            &-text {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #777777;
                display: flex;
                align-items: center;
            }

            a {
                color: #0cc4b9ff;
            }
        }

        &-operation {
            margin: 0px 20px auto;

            .van-button {
                width: 335px;
                height: 42px;
                border-radius: 22px;
                margin-bottom: 36px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/overlay/recommend.vue